module.exports = __webpack_public_path__ + "static/media/substitute.svg.f561f1b7.png";